module.exports = __webpack_public_path__ + "img/big5-3.4ab4e98b.jpg";